import React from 'react';
import { useSpinradContext } from '../../context/SpinradContext';
import { Actions, Box, CancelBtn, Msg, OkBtn, Overlay, Title } from './styles';

const ConfirmDialog: React.FC = () => {
  const { confirm, closeConfirm, confirmOk } = useSpinradContext();

  return (
    <Overlay
      $open={confirm.isOpen}
      onClick={e => {
        if (e.target === e.currentTarget) closeConfirm();
      }}
    >
      <Box>
        <Title>{confirm.title}</Title>
        {confirm.message && <Msg>{confirm.message}</Msg>}
        <Actions>
          <OkBtn type="button" onClick={confirmOk}>
            {confirm.okLabel}
          </OkBtn>
          <CancelBtn type="button" onClick={closeConfirm}>
            Abbrechen
          </CancelBtn>
        </Actions>
      </Box>
    </Overlay>
  );
};

export default ConfirmDialog;
